import React from 'react'
import DataMonitor1 from "../Dashboard/App1.js"
const DataMonitor = () => {
    return (
        <DataMonitor1/>
    )
}

export default DataMonitor
